export default __webpack_public_path__ + "static/media/3.Bagshiin_hugjil.c6272ed3.png";